import React from "react";
import { Button, Paper } from "@mui/material";
import styles from "../../styles/common/error404.module.css";

const LoadingError: React.FC<{
  h1: string;
  hideReset?: boolean;
  customeReset?: any;
}> = (props) => {
  return (
    <div className={styles.container1}>
      <Paper elevation={5} className={styles.errorContainer}>
        <h1>{props.h1}</h1>
        {!props.hideReset && !props.customeReset && (
          <>
            <p>Please try again with a valid input or reload the page.</p>
            <Button
              onClick={() => {
                window.location.reload();
              }}
              variant="contained"
              fullWidth
            >
              Reset Filters
            </Button>
          </>
        )}

        {!props.hideReset && props.customeReset && (
          <>
            <p>{props.customeReset.head}</p>
            <Button
              onClick={() => props.customeReset.resetHandler()}
              variant="contained"
              fullWidth
            >
              {props.customeReset.subhead}
            </Button>
          </>
        )}
      </Paper>
    </div>
  );
};

export default LoadingError;
